import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Table, TableBody, TableCell, TableRow } from "@material-ui/core";

import ListaDetalle from "../components/ListaDetalle";
import MenuDetalle from "../components/MenuDetalle";
import ModalSolicitud from "../components/ModalSolicitud";
import { Cargando, EstadoVacio } from "../components/Estados";

import { useConsulta } from "../hooks/useConsulta";
import { obtenerSolicitudGestion } from "../services/bibliotecaApi";
import { VISTA_DETALLE } from "../constants";
import { buscarPorCodigo, menuDetalleGestion } from "../catalogo";
import { filasInformacionBasica, itemsDeDetalle } from "../model/presentacion";

/**
 * Pestaña Solicitud: solo los datos basicos. Auxiliares e historial tienen
 * su propia pestaña.
 */
const DatosSolicitud = ({ solicitud }) => (
  <Table size="small">
    <TableBody>
      {filasInformacionBasica(solicitud).map(([etiqueta, valor]) => (
        <TableRow key={etiqueta}>
          <TableCell style={{ width: "35%" }}>{etiqueta}</TableCell>
          <TableCell>{valor}</TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

DatosSolicitud.propTypes = { solicitud: PropTypes.object.isRequired };

/** Si quien la ve tiene algo que hacer con ella: estado, auxiliares o ejemplares. */
export const sePuedeGestionar = (solicitud) =>
  Boolean(
    solicitud?.acciones?.length || solicitud?.maneja_auxiliares || solicitud?.maneja_ejemplares,
  );

/**
 * El boton Abrir de la tabla de Gestion, como el detalle de Gestion
 * Practicas: la solicitud completa en un modal con pestañas (los datos, los
 * estudiantes, el material, los ejemplares, los auxiliares y el historial).
 *
 * Si quien la ve puede gestionarla, abajo esta el boton para pasar al modal
 * Gestionar.
 */
const ModalDetalleGestion = ({ id, version, onCerrar, onGestionar }) => {
  const [vista, setVista] = useState(VISTA_DETALLE.SOLICITUD);
  const { datos: solicitud, cargando, error } = useConsulta(
    () => obtenerSolicitudGestion(id),
    [id, version],
    null,
  );

  const pestanas = menuDetalleGestion(solicitud?.tipo_solicitud?.codigo);
  const { vacio } = buscarPorCodigo(pestanas, vista) ?? {};

  const contenido = () => {
    if (cargando && !solicitud) return <Cargando />;
    if (error || !solicitud) {
      return <EstadoVacio mensaje={error?.message ?? "No fue posible cargar la solicitud"} />;
    }
    if (vista === VISTA_DETALLE.SOLICITUD) return <DatosSolicitud solicitud={solicitud} />;
    return (
      <ListaDetalle
        items={itemsDeDetalle(vista, solicitud)}
        vacio={vacio ?? "No hay nada que mostrar"}
      />
    );
  };

  return (
    <ModalSolicitud
      titulo="¡ Detalle Solicitud !"
      onCerrar={onCerrar}
      menu={
        solicitud && (
          <MenuDetalle opciones={pestanas} seleccion={vista} onSeleccionar={setVista} />
        )
      }
      acciones={
        onGestionar && sePuedeGestionar(solicitud) ? (
          <Button color="primary" onClick={() => onGestionar(id)}>
            Gestionar
          </Button>
        ) : null
      }
    >
      {contenido()}
    </ModalSolicitud>
  );
};

ModalDetalleGestion.propTypes = {
  id: PropTypes.number.isRequired,
  /** Cambiarla vuelve a consultar, tras gestionar desde otro modal. */
  version: PropTypes.number,
  onCerrar: PropTypes.func.isRequired,
  /** Recibe el id; sin ella no se ofrece gestionar. */
  onGestionar: PropTypes.func,
};

ModalDetalleGestion.defaultProps = { version: 0, onGestionar: null };

export default ModalDetalleGestion;
